import React from 'react'
import { useParams } from 'react-router-dom'

import { AssessmentProcessProvider } from './AssessmentProcessProvider'

interface AssessmentProcessProviderWrapperProps {
  children: React.ReactNode
}

export const AssessmentProcessProviderWrapper: React.FC<AssessmentProcessProviderWrapperProps> = ({
  children
}) => {
  const { id } = useParams<{ id: string }>()

  if (!id) {
    throw new Error('Assessment ID is required')
  }

  return <AssessmentProcessProvider assessmentId={id}>{children}</AssessmentProcessProvider>
}
